import {LoadingPlaceholder} from "@communicare/medications/Components/Placeholder";
import {LayoutCentral} from "@communicare/medications/Components/LayoutCentral";
import {LoadingError} from "@communicare/medications/Components/SplashScreens/LoadingError";
import {NoResults} from "@communicare/medications/Components/SplashScreens/NoResults";
import React from "react";


export interface IComponentLoaderProps{
    inProgress: boolean;
    error: any;
    empty: boolean;
    emptyResultMessage?:string;
    children: JSX.Element
}

export const ComponentLoader = (props: IComponentLoaderProps) => {
    if (props.inProgress) {
        return <LoadingPlaceholder/>
    }
    if (props.error) {
        return <LayoutCentral>
            <LoadingError/>
        </LayoutCentral>
    }

    if (props.empty) {
        return <LayoutCentral>
            <NoResults
                title={'No results found.'}
                info={
                    props.emptyResultMessage
                }
            />
        </LayoutCentral>
    }

    return <>{props.children}</>;
}